import { UuidResourceParam, uuidSerializer } from "@legacy-megarax/common";
import { BaseResource, ResourceActionV2 } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

import { customerDetailSerializer } from "./customerDetail";
import {
  changeStatusInputSerializer,
  designateVisitLocationInputSerializer,
  renameCustomerInputSerialized,
  tagCustomerInputSerializer,
} from "./inputs";

export const customerResource = BaseResource(["crm", "customers"], {
  allCustomers: ResourceActionV2({
    name: "allCustomers",
    method: "get",
    responseValueSerializer: MSerializers.array(customerDetailSerializer),
  }),

  bulkRetrieve: ResourceActionV2({
    name: "bulkRetrieve",
    method: "post",
    requestBodySerializer: MSerializers.array(uuidSerializer),
    responseValueSerializer: MSerializers.array(customerDetailSerializer.nullable()),
  }),

  bulkRegisterFromCsv: ResourceActionV2({
    name: "bulkRegisterFromCsv",
    method: "post",
    requestBodySerializer: MSerializers.object<{ csv: string }>({ csv: MSerializers.string }),
  }),

  byUuid: UuidResourceParam("uuid", "uuid", {
    designateVisitLocation: ResourceActionV2({
      name: "designateVisitLocation",
      method: "post",
      path: "designateVisitLocation",
      requestBodySerializer: designateVisitLocationInputSerializer,
      responseErrorSerializer: MSerializers.identity<"CustomerNotFound">(),
    }),
    renameCustomer: ResourceActionV2({
      name: "renameCustomer",
      method: "put",
      path: "renameCustomer",
      requestBodySerializer: renameCustomerInputSerialized,
      responseErrorSerializer: MSerializers.identity<"CustomerNotFound" | "CustomerWithThatNameExists">(),
    }),
    tagCustomer: ResourceActionV2({
      name: "tagCustomer",
      method: "put",
      path: "tagCustomer",
      requestBodySerializer: tagCustomerInputSerializer,
      responseErrorSerializer: MSerializers.identity<"CustomerNotFound" | "TagAlreadyAssigned">(),
    }),
    untagCustomer: ResourceActionV2({
      name: "untagCustomer",
      method: "put",
      path: "untagCustomer",
      requestBodySerializer: tagCustomerInputSerializer,
      responseErrorSerializer: MSerializers.identity<"CustomerNotFound" | "TagNotAssigned">(),
    }),
    changeStatus: ResourceActionV2({
      name: "changeStatus",
      method: "put",
      requestBodySerializer: changeStatusInputSerializer,
      responseErrorSerializer: MSerializers.stringOneOf("CustomerNotFound"),
    }),
    retrieve: ResourceActionV2({
      name: "retrieve",
      method: "get",
      path: "",
      responseValueSerializer: customerDetailSerializer,
      responseErrorSerializer: MSerializers.identity<any>(),
    }),
  }),
});
